import { render } from "./call.vue?vue&type=template&id=75b30dcd&scoped=true&ts=true"
import script from "./call.vue?vue&type=script&lang=ts"
export * from "./call.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=75b30dcd&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b30dcd"]])

export default __exports__